import { useParams } from "react-router-dom";
import { useSuccess } from "./useSuccess";
import { CopyToClipboard } from "@utils/copyToClipBoard";

import { GrStatusGood } from "react-icons/gr";
import { IoCopyOutline } from "react-icons/io5";

//components
import { Button } from "@atoms";

export const Success = () => {
  const { os, item } = useParams();
  const helper = useSuccess();

  return (
    <div className="w-[full]">
      <div className="w-[full] h-[75vh] flex items-center justify-center flex-col">
        <GrStatusGood className="text-[green] size-[45px]" />
        <h3 className="text-[22px] text-[green] mt-[5px]">{item} criado com sucesso!</h3>
        <div className="w-[220px] flex items-center justify-between bg-white px-[30px] py-[15px] shadow-[0px_0px_25px_0px_rgba(0,0,0,0.3)]">
          <div className="flex items-center text-[16px]">
            Ticket:{" "}
            <button
              className="bg-[white] border-none text-[16px] text-[blue] underline cursor-pointer"
              onClick={() => {
                helper.openTicketWindow(os || "");
              }}
            >
              {os}
            </button>
          </div>
          <button
            className="bg-[white] border-none cursor-pointer text-[18px]"
            onClick={() => {
              CopyToClipboard(os || "");
            }}
          >
            <IoCopyOutline />
          </button>
        </div>
      </div>
      <div className="w-full flex justify-center">
        <Button onClick={helper.backPage} style={{ width: "100%" }}>
          Voltar
        </Button>
      </div>
    </div>
  );
};
